// extracted by mini-css-extract-plugin
module.exports = {"root":"EventPage_root__1qStT","submitButton":"EventPage_submitButton__RDzd9","selectcontrol":"EventPage_selectcontrol__3SYVj"};